import { Collection } from "@/core/magnet";

export default Collection.extend({
  url: "interests",
  parse: function (response) {
    return response.data;
  },
});
